import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import zh from './lang/zh'
import en from './lang/en'
import tw from './lang/tw'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import {getStore, setStore} from '@/publicResource/utils/utils.js'

Vue.use(VueI18n)

const messages = {
  en_US: Object.assign(en, enLocale),
  zh_CN: Object.assign(zh, zhLocale),
  zh_TW: Object.assign(tw, twLocale)
}
let lang = ''
if (navigator.language) {
  lang = navigator.language === 'zh-CN' ? 'zh_CN' : 'en_US'
} else {
  lang = navigator.browserLanguage === 'zh-CN' ? 'zh_CN' : 'en_US'
}

if (getStore('locale')) {
  lang = getStore('locale')
  setStore('locale', lang)
} else {
  setStore('locale', lang)
}
console.log(lang)
const i18n = new VueI18n({
  locale: lang || 'en_US',
  messages
})

locale.i18n((key, value) => i18n.t(key, value)) // 为了实现element插件的多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/publicResource/utils/i18n.js